import { getQueryStringVariable } from "./getQueryStringVariable";

export function isLoadedInIframe() {
    const isLoadedInIframe =   getQueryStringVariable('isLoadedInIframe') == 'true';
    try {
        return isLoadedInIframe || window.self !== window.top;
    } catch (e) {
        return true;
    }
}
